import React from 'react';
import Ingredient from './Ingredient';
import * as a from './../actions';
import {connect} from "react-redux";

function IngredientGroup({group, unpackGroup, collapseGroup})  {

    let ingredientsHtml = group.collapsed ? '' : (
        <div className="ingredient-group__ingredients">
            {group.ingredients.map(ingredient => <Ingredient ingredient={ingredient} key={ingredient.id}/>)}
        </div>
    );

    return (
        <div className="ingredient-group">
            <button
                onClick={group.collapsed ? unpackGroup(group) : collapseGroup(group) }
                className={`ingredient-group__dropdown ${group.collapsed ? 'ingredient-group__dropdown--collapsed' : ''} btn btn--${group.collapsed ? 'secondary' : 'primary'}`}>
                <span>{group.label}</span>
                <svg className="ingredient-group__dropdown-arrow" width="24" height="24">
                    <use xlinkHref="#ic_arrow_down"></use>
                </svg>
            </button>
            {ingredientsHtml}
        </div>
    );
}

export default connect(
    null,
    dispatch => ({
        collapseGroup: group => () => dispatch(a.collapseGroup(group)),
        unpackGroup: group => () => dispatch(a.unpackGroup(group))
    })
)(IngredientGroup);
